import { formInformation, storagePage } from '../storage'

type DetailBlock = Record<string, any> | null | undefined

function optionFromId(id: number | null | undefined) {
    if (id == null) return null
    return { label: '', value: String(id) }
}

function idsToOptions(ids: number[] | undefined) {
    return (ids || []).map(id => ({ label: '', value: String(id) }))
}

function photoFromDetails(details: DetailBlock) {
    const photoId = details?.photo_file_id
    return photoId != null ? photoId.toString() : ''
}

function clearTypeSpecificFields() {
    formInformation.setValue('measurement_range', '')
    formInformation.setValue('model', '')
    formInformation.setValue('composition', '')
    formInformation.setValue('useful_life', null)
    formInformation.setValue('packaging', null)
    formInformation.setValue('presentation_quantity', '')
    formInformation.setValue('presentation_unit', null)
    formInformation.setValue('regulation', null)
    formInformation.setValue('certificate', false)
    formInformation.setValue('air_transport', false)
    formInformation.setValue('maritime_transport', false)
    formInformation.setValue('refrigeration', false)
    formInformation.setValue('impact_ecosystem', [])
    formInformation.setValue('productive_process', [])
    formInformation.setValue('vertical_market', [])
    formInformation.setValue('services', [])
    formInformation.setValue('certification', [])
}

/** Rellena el formulario con los detalles guardados del tipo elegido (edición). */
export default function applyTypeDetailsToForm(typeIndex: number) {
    const product = storagePage.product as Record<string, any> | null
    if (!product || storagePage.mode !== 'edition') {
        return
    }

    const equipment = product.equipment_details as DetailBlock
    const consumable = product.consumable_details as DetailBlock
    const service = product.service_details as DetailBlock

    clearTypeSpecificFields()

    if (typeIndex === 0 && equipment) {
        formInformation.setValue('name', equipment.description || '')
        formInformation.setValue(
            'manufacturer_code',
            equipment.manufacturer_code || ''
        )
        formInformation.setValue('model', equipment.equipment_model || '')
        formInformation.setValue(
            'measurement_range',
            equipment.measurement_range || ''
        )
        if (equipment.brand_id != null) {
            const currentBrand = formInformation.store().brand
            formInformation.setValue('brand', {
                label:
                    currentBrand?.value === String(equipment.brand_id)
                        ? currentBrand.label
                        : '',
                value: String(equipment.brand_id)
            })
        }
        formInformation.setValue(
            'fiscal_code_ni',
            equipment.fiscal_code_ni || ''
        )
        formInformation.setValue(
            'fiscal_code_cr',
            equipment.fiscal_code_cr || ''
        )
        formInformation.setValue(
            'fiscal_code_pa',
            equipment.fiscal_code_pa || ''
        )
        formInformation.setValue(
            'fiscal_code_ve',
            equipment.fiscal_code_ve || ''
        )
        formInformation.setValue('photo', photoFromDetails(equipment))
        formInformation.setValue(
            'impact_ecosystem',
            idsToOptions(equipment.impact_ecosystem_ids)
        )
        formInformation.setValue(
            'productive_process',
            idsToOptions(equipment.productive_process_ids)
        )
        formInformation.setValue(
            'vertical_market',
            idsToOptions(equipment.vertical_market_ids)
        )
        formInformation.setValue(
            'services',
            idsToOptions(equipment.service_ids)
        )
        formInformation.setValue(
            'certification',
            idsToOptions(equipment.certification_ids)
        )
        return
    }

    if (typeIndex === 1 && consumable) {
        formInformation.setValue('name', consumable.description || '')
        formInformation.setValue(
            'manufacturer_code',
            consumable.manufacturer_code || ''
        )
        if (consumable.brand_id != null) {
            const currentBrand = formInformation.store().brand
            formInformation.setValue('brand', {
                label:
                    currentBrand?.value === String(consumable.brand_id)
                        ? currentBrand.label
                        : '',
                value: String(consumable.brand_id)
            })
        }
        formInformation.setValue('composition', consumable.composition || '')
        formInformation.setValue(
            'useful_life',
            optionFromId(consumable.useful_life_id)
        )
        formInformation.setValue(
            'packaging',
            optionFromId(consumable.packaging_id)
        )
        formInformation.setValue(
            'regulation',
            optionFromId(consumable.regulation_id)
        )
        formInformation.setValue(
            'presentation_quantity',
            consumable.presentation_quantity != null
                ? String(consumable.presentation_quantity)
                : ''
        )
        formInformation.setValue(
            'presentation_unit',
            optionFromId(consumable.presentation_unit_id)
        )
        formInformation.setValue(
            'air_transport',
            consumable.air_transport || false
        )
        formInformation.setValue(
            'maritime_transport',
            consumable.maritime_transport || false
        )
        formInformation.setValue(
            'refrigeration',
            consumable.refrigeration || false
        )
        formInformation.setValue(
            'fiscal_code_ni',
            consumable.fiscal_code_ni || ''
        )
        formInformation.setValue(
            'fiscal_code_cr',
            consumable.fiscal_code_cr || ''
        )
        formInformation.setValue(
            'fiscal_code_pa',
            consumable.fiscal_code_pa || ''
        )
        formInformation.setValue(
            'fiscal_code_ve',
            consumable.fiscal_code_ve || ''
        )
        formInformation.setValue('photo', photoFromDetails(consumable))
        formInformation.setValue(
            'impact_ecosystem',
            idsToOptions(consumable.impact_ecosystem_ids)
        )
        formInformation.setValue(
            'productive_process',
            idsToOptions(consumable.productive_process_ids)
        )
        formInformation.setValue(
            'vertical_market',
            idsToOptions(consumable.vertical_market_ids)
        )
        formInformation.setValue(
            'certification',
            idsToOptions(consumable.certification_ids)
        )
        return
    }

    if (typeIndex === 2 && service) {
        formInformation.setValue('name', service.description || '')
        formInformation.setValue(
            'manufacturer_code',
            service.manufacturer_code || ''
        )
        formInformation.setValue('certificate', service.certificate || false)
        formInformation.setValue('fiscal_code_ni', service.fiscal_code_ni || '')
        formInformation.setValue('fiscal_code_cr', service.fiscal_code_cr || '')
        formInformation.setValue('fiscal_code_pa', service.fiscal_code_pa || '')
        formInformation.setValue('fiscal_code_ve', service.fiscal_code_ve || '')
        formInformation.setValue('photo', photoFromDetails(service))
        formInformation.setValue(
            'certification',
            idsToOptions(service.certification_ids)
        )
    }
}
